import request from '@/utils/request'

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/user/getUserList',
    method: 'post',
    data: query
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/user/getUserById',
    method: 'post',
    data: {id:userId}
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/user/saveAndUpdateUser',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/user/saveAndUpdateUser',
    method: 'post',
    data: data
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/user/deleteUser/' + userId,
    method: 'get'
  })
}

// 用户密码重置
export function resetUserPwd(id, loginPwd) {
  const data = {
    id,
    loginPwd
  }
  return request({
    url: '/loginaccount/changePwd',
    method: 'post',
    data: data
  })
}

// 用户状态修改
export function changeUserStatus(id, status) {
  const data = {
    id,
    status
  }
  return request({
    url: '/loginaccount/changeStatus',
    method: 'post',
    data: data
  })
}

// 获取列表数据(根据企业id)
export function getChildTalbeListByPage(data) {
    return request({
        url: '/user/getChildTalbeListByPage',
        method: 'POST',
        data: data
    })
}